import {
  Button,
  Card,
  InlineError,
  Form,
  SkeletonBodyText,
  Box,
} from '@shopify/polaris'

import CodeEditor from '../../../../components/CodeEditor'
import CollapsableErrorWindow from '../../../../components/CollapsableErrorWindow'

function Javascript({ config, form }) {
  return (
    <Form onSubmit={form.submit}>
      <div
        style={{
          padding: 'var(--p-space-400) var(--p-space-400) var(--p-space-400) 0',
          position: 'relative',
        }}
      >
        {form.fields.jsEditor.error && (
          <InlineError message={form.fields.jsEditor.error} />
        )}
        <CodeEditor
          onChange={form.fields.jsEditor.onChange}
          loading={
            <Box padding={'400'}>
              <SkeletonBodyText lines={20} />
            </Box>
          }
          value={form.fields.jsEditor.value}
          mode={'javascript'}
          height={500}
        />

        <div
          style={{
            paddingLeft: 'var(--p-space-400)',
          }}
        >
          <Button
            submit
            loading={form.submitting}
            variant="primary"
            size="large"
          >
            Save
          </Button>
        </div>

        <CollapsableErrorWindow error={config.jsError} />
      </div>
    </Form>
  )
}

export default Javascript
